<script>
export default {
  props: {
    classText: { type: String, default: '' },
    errorMsg: { type: String, default: '' },
  },

  computed: {
    classForText: function () {
      let classResult = 'text-left w-100'
      let splitClass = this.classText.split(' ')
      if (
        !splitClass.find(function (val) {
          return val.substring(0, 3) === 'fs-'
        })
      ) {
        classResult += ' fs-14'
      }
      if (
        !splitClass.find(function (val) {
          return val.substring(0, 3) === 'fw-'
        })
      ) {
        classResult += ' fw-700'
      }
      if (
        !splitClass.find(function (val) {
          return val.substring(0, 3) === 'mt-'
        })
      ) {
        classResult += ' mt-3'
      }
      if (this.classText && this.classText.length > 0) {
        classResult += ' ' + this.classText
      }

      return classResult.trim()
    },
  },
}
</script>
<template>
  <div class="media flex-column align-items-center">
    <span class="avatar avatar-xl bg-danger mx-auto">
      <i class="ti-alert fw-700 fs-30 align-sub"></i>
    </span>
    <span :class="classForText">
      <slot></slot>
    </span>
  </div>
</template>
